import _sfc_main from "./SwitchAudioRoute.vue2.mjs";
/* empty css                       */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "audio-route-icon" }, [_c(_setup.SvgIcon, { directives: [{ name: "tap", rawName: "v-tap", value: _setup.handleSwitchAudioRoute, expression: "handleSwitchAudioRoute" }], attrs: { "icon": _setup.icon } })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "d81a1810"
);
const SwitchAudioRoute = __component__.exports;
export {
  SwitchAudioRoute as default
};
